import axios from 'axios';

export function enterAdvancedMode(campaignId, stepId, link) {
  return axios.post(`/api/?entity=campaigns&action=enter-advanced-mode&cid=${campaignId}&step_id=${stepId}`, {
    link,
  });
}
